/* eslint-disable @foundershub/fluent */
import * as React from 'react';
import { Body1, Link, makeStyles, tokens } from '@fluentui/react-components';
import { defineMessage, useIntl } from 'react-intl';

export function FooterSimple() {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <nav className={classes.nav}>
        <div role="list" className={classes.links}>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://aka.ms/yourcaliforniaprivacychoices"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(privacyChoicesLabel)}</Body1>
            </Link>
          </div>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://www.microsoft.com/en-US/legal/intellectualproperty/copyright"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(termsLabel)}</Body1>
            </Link>
          </div>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://go.microsoft.com/fwlink/?LinkId=521839"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(privacyLabel)}</Body1>
            </Link>
          </div>
          <div role="listitem">
            <Link
              className={classes.link}
              href="https://www.microsoft.com/en-US/legal/intellectualproperty/trademarks/usage/general"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Body1>{intl.formatMessage(trademarksLabel)}</Body1>
            </Link>
          </div>
        </div>
      </nav>
    </footer>
  );
}

const privacyChoicesLabel = defineMessage({
  defaultMessage: 'Your privacy choices',
  description: 'footer get help link text',
});
const termsLabel = defineMessage({
  defaultMessage: 'Terms of use',
  description: 'footer terms link text',
});
const privacyLabel = defineMessage({
  defaultMessage: 'Privacy and cookies',
  description: 'footer privacy link text',
});
const trademarksLabel = defineMessage({
  defaultMessage: 'Trademarks',
  description: 'footer feedback link text',
});

const useStyles = makeStyles({
  footer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 16px 42px',
  },
  nav: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
  },
  links: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 1,
    maxWidth: '460px',
  },
  link: {
    color: '#424242',
    ':hover': {
      textDecoration: 'none',
      color: tokens.colorPaletteBlueBorderActive,
    },
    '&:focus-visible': {
      outline: '1.5px solid', // Customize the box style as needed
      outlineOffset: '1px',
      textDecoration: 'none', // Remove default underline
      boxShadow: '0 0 0 1px',
    },
  },
});
